module.exports = __webpack_public_path__ + "static/media/Philanthropy.6ee8c05a.svg";